module.exports = __webpack_public_path__ + "img/爱尔铃.png";